import { Sentry } from './sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { customTheme } from './theme/customTheme';
import Fonts from './theme/Fonts';
import { Provider } from 'react-redux';
import { store } from './store/redux/store';

createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <React.StrictMode>
      <ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
      <ChakraProvider
        resetCSS
        theme={customTheme}
        toastOptions={{
          defaultOptions: {
            position: 'bottom',
            containerStyle: {
              m: '6px',
              // Only the lowest toast clears the screen edge; the rest just
              // need a gap, otherwise every toast repeats the full offset.
              '.chakra-toast:last-of-type &': {
                mb: '36px',
              },
            },
          },
        }}
      >
        <Fonts />
        <Provider store={store}>
          <App />
        </Provider>
      </ChakraProvider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// App.listen(port, () => {
//   console.log(`Server listening on port ${port}`);
// });
